//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  data: function data() {
    return {
      visible: false,
      details: {} // 预留一份数据
    };
  },
  mounted: function mounted() {},
  methods: {
    initOpen: function initOpen() {
      var details = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.details = details;
      this.visible = true;
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};